'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    navSectionHeaderClassNames: function() {
        return navSectionHeaderClassNames;
    },
    useNavSectionHeaderStyles_unstable: function() {
        return useNavSectionHeaderStyles_unstable;
    }
});
const _react = require("@griffel/react");
const navSectionHeaderClassNames = {
    root: 'fui-NavSectionHeader'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Jyy4pa: "f1gr6hdk",
        Bo78w4l: 0,
        Cgygva: 0,
        yil37a: "f1ulrxyd",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fwrc4pm"
    }
}, {
    d: [
        ".f1gr6hdk{-webkit-margin-start:10px;margin-inline-start:10px;}",
        [
            ".f1ulrxyd{margin-block:8px;}",
            {
                p: -1
            }
        ],
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}"
    ]
});
const useNavSectionHeaderStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(navSectionHeaderClassNames.root, styles.root, state.root.className);
    return state;
};
